import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaintenanceRecordDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/maintenance-record/maintenance-record-dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ListMaintenanceService {

  constructor(private httpClient: HttpClient) { }

  listMaintenance(vehicleId: number) {
    return this.httpClient.get<MaintenanceRecordDto[]>(`${environment.apiServer}/Adjuster/Claim/ListMaintenanceRecord`, { params: { vehicleId }});
  }
}
